export default {
  install(Vue, option) {
    Vue.prototype.$common = new (function() {
      const isDev = window.location.hostname.includes('localhost')

      this.log = value => {
        if (isDev) {
          console.log(value)
        }
      }

      this.error = value => {
        if (isDev) {
          console.error(value)
        }
      }

      this.logData = (data, title = '') => {
        if (isDev) {
          if (title !== '') {
            console.log(`------------- ${title} -------------`)
          }
          console.log(JSON.parse(JSON.stringify(data)))
        }
      }

      this.duplicateData = data => {
        return JSON.parse(JSON.stringify(data))
      }

      this.diffQuery = (newQuery, oldQuery) => {
        Object.keys(newQuery).forEach(key => {
          if (newQuery[key] === null || newQuery[key] === '' || (key === 'searchType' && !newQuery['search'])) {
            delete newQuery[key]
          }
        })

        if (Object.keys(newQuery).length !== Object.keys(oldQuery).length) {
          return newQuery
        }

        let diff = false
        const keys = Object.keys(newQuery)
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          if (newQuery[key] != oldQuery[key]) {
            diff = true
            break
          }
        }

        if (diff) {
          return newQuery
        } else {
          return null
        }
      }

      // ============ File Function =================
      this.getAcceptFileFormat = type => {
        let fileFormatStr = ''
        let fileFormatArr = []

        if (type === 'image') {
          fileFormatStr = 'image/jpeg,image/jpg,image/png'
          fileFormatArr = ['png', 'jpeg', 'jpg']
        } else if (type === 'video') {
          fileFormatStr = 'video/mp4,video/webm'
          fileFormatArr = ['mp4', 'webm']
        } else if (type === 'imageWithPDF') {
          fileFormatStr = 'image/jpeg,image/jpg,image/png,application/pdf'
          fileFormatArr = ['png', 'jpeg', 'jpg', 'pdf']
        }

        if (Vue.prototype.$validate.DataValid(fileFormatStr) && Vue.prototype.$validate.DataValid(fileFormatArr)) {
          return {
            formatStr: fileFormatStr,
            formatArr: fileFormatArr,
          }
        }

        return null
      }

      // ============ Course Function =================
      this.getStartTimeOptions = (interval = 0) => {
        let _interval = interval > 0 ? interval : Vue.prototype.$settings.interval
        const startTime = Vue.prototype.$settings.startTime
        const endTime = Vue.prototype.$settings.endTime
        const list = []
        const endTimeDate = Vue.prototype.$formatter.getDateObj(`2023-01-01T${endTime}:00Z`)
        const tempDate = Vue.prototype.$formatter.getDateObj(`2023-01-01T${startTime}:00Z`)

        while (tempDate.getTime() < endTimeDate.getTime()) {
          list.push(
            `${Vue.prototype.$formatter.pad(tempDate.getHours())}:${Vue.prototype.$formatter.pad(
              tempDate.getMinutes(),
            )}`,
          )
          tempDate.setTime(tempDate.getTime() + _interval * 60 * 1000)
        }

        return list
      }

      this.getEndTimeOptions = (startTime, interval = 0) => {
        if (!startTime || !/^\d{2}:\d{2}$/.test(startTime)) {
          return []
        }

        let _interval = interval > 0 ? interval : Vue.prototype.$settings.interval
        const endTime = Vue.prototype.$settings.endTime
        const endTimeDate = Vue.prototype.$formatter.getDateObj(`2023-01-01T${endTime}:00Z`)
        const tempDate = Vue.prototype.$formatter.getDateObj(`2023-01-01T${startTime}:00Z`)

        const list = []
        while (tempDate.getTime() <= endTimeDate.getTime()) {
          tempDate.setTime(tempDate.getTime() + _interval * 60 * 1000)
          if (tempDate.getTime() <= endTimeDate.getTime()) {
            list.push(
              `${Vue.prototype.$formatter.pad(tempDate.getHours())}:${Vue.prototype.$formatter.pad(
                tempDate.getMinutes(),
              )}`,
            )
          }
        }

        return list
      }

      this.getContrastTextColor = hex => {
        const { h, s, l } = hexToHSL(hex)
        const backgroundColor = `hsl(${h} ${s}% ${l}%)`
        const color = `hsl(0 0% calc((${l}% - 50%) * -999)) !important`
        return { color, backgroundColor, style: { 'background-color': backgroundColor, color: color } }
      }

      /**
       * @param {Array<{start_time: string, end_time:string}>} shiftTimeList in hh:mm format
       * @param {string} startTimeRange in hh:mm format
       * @param {string} endTimeRange in hh:mm format
       * @returns {Array<{start_time: string, end_time:string}>} a list of time cannot make appointment
       */
      this.searchBlockTimeslot = (shiftTimeList, startTimeRange, endTimeRange) => {
        const rangeStart = this.timeToMinutes(startTimeRange)
        const rangeEnd = this.timeToMinutes(endTimeRange)

        // Convert and filter shifts to those overlapping the range
        let shifts = shiftTimeList
          .map(s => ({ start: this.timeToMinutes(s.start_time), end: this.timeToMinutes(s.end_time) }))
          .filter(s => s.end > rangeStart && s.start < rangeEnd)
          .sort((a, b) => a.start - b.start)

        // Merge overlapping shifts
        shifts = shifts.reduce((acc, shift) => {
          if (acc.length === 0 || shift.start > acc[acc.length - 1].end) {
            acc.push(shift)
          } else {
            acc[acc.length - 1].end = Math.max(acc[acc.length - 1].end, shift.end)
          }
          return acc
        }, [])

        // Extract available time slots
        const available = []
        let currentTime = rangeStart

        for (const shift of shifts) {
          const gapEnd = shift.start
          if (currentTime <= gapEnd) {
            available.push({
              start_time: this.minutesToTime(currentTime),
              end_time: this.minutesToTime(gapEnd),
            })
          }
          currentTime = shift.end
        }

        // Add final gap if any
        if (currentTime <= rangeEnd) {
          available.push({
            start_time: this.minutesToTime(currentTime),
            end_time: this.minutesToTime(rangeEnd),
          })
        }

        return available
      }

      /**
       * all the input is hh:mm format
       * check whether startTime and endTime is within timeslotStart and timeslotEnd
       * @param {string} startTime
       * @param {string} endTime
       * @param {string} timeslotStart
       * @param {string} timeslotEnd
       */
      this.checkTimeWithinTimeslot = (startTime, endTime, timeslotStart, timeslotEnd) => {
        const sTime = this.timeToMinutes(startTime)
        const eTime = this.timeToMinutes(endTime)
        const tStart = this.timeToMinutes(timeslotStart)
        const tEnd = this.timeToMinutes(timeslotEnd)

        // Case 1: Standard timeslot (e.g., 09:00 - 17:00)
        if (tStart < tEnd) {
          return sTime >= tStart && eTime <= tEnd
        }

        // Case 2: Overnight timeslot (e.g., 22:00 - 06:00)
        // The range is valid if the duration falls entirely within the "late" part
        // or the "early" part of the overnight shift.
        else {
          // Check if the range is entirely within the split overnight period
          return (sTime >= tStart || sTime <= tEnd) && (eTime >= tStart || eTime <= tEnd) && sTime <= eTime
        }
      }

      this.timeToMinutes = timeStr => {
        const [hours, minutes] = timeStr.split(':').map(Number)
        return (hours || 0) * 60 + (minutes || 0)
      }

      this.minutesToTime = minutes => {
        if (!isNaN(minutes)) {
          const h = Math.floor(minutes / 60)
          const m = minutes % 60
          return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
        }
        return ''
      }
    })()
  },
}

// https://gist.github.com/xenozauros/f6e185c8de2a04cdfecf
function hexToHSL(hex) {
  // 1. Remove '#' and convert shorthand (#f00) to full (#ff0000)
  hex = hex.replace(/^#/, '')
  if (hex.length === 3) {
    hex = hex
      .split('')
      .map(char => char + char)
      .join('')
  }

  // 2. Parse RGB values (0-255)
  let r = parseInt(hex.substring(0, 2), 16) / 255
  let g = parseInt(hex.substring(2, 4), 16) / 255
  let b = parseInt(hex.substring(4, 6), 16) / 255

  // 3. Find min/max and calculate lightness
  const max = Math.max(r, g, b),
    min = Math.min(r, g, b)
  let h,
    s,
    l = (max + min) / 2

  if (max === min) {
    h = s = 0 // achromatic
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h /= 6
  }

  // 4. Return as percentage values for CSS
  return { h: Math.round(h * 360), s: Math.round(s * 100), l: Math.round(l * 100) }
}
